import { splitTimerTime } from './practice-timer.js';

const SEGMENTS_BY_DIGIT = Object.freeze({
  0: 'abcdef',
  1: 'bc',
  2: 'abdeg',
  3: 'abcdg',
  4: 'bcfg',
  5: 'acdfg',
  6: 'acdefg',
  7: 'abc',
  8: 'abcdefg',
  9: 'abcdfg',
});

function sevenSegmentDigitTemplate(label) {
  return `<span class="segment-digit" data-timer-digit aria-label="${label}">
    ${'abcdefg'.split('').map((segment) => `<i class="segment segment-${segment}" data-segment="${segment}"></i>`).join('')}
  </span>`;
}

export function timerDisplayTemplate({ className = '', state = 'idle' } = {}) {
  return `<div class="timer-display${className ? ` ${className}` : ''}" data-timer-display data-timer-state="${state}" role="timer" aria-label="计时 00分00秒000毫秒">
    <div class="timer-digit-bank timer-minute-bank" aria-hidden="true">
      ${sevenSegmentDigitTemplate('分钟十位')}
      ${sevenSegmentDigitTemplate('分钟个位')}
    </div>
    <span class="timer-colon" aria-hidden="true"><i></i><i></i></span>
    <div class="timer-digit-bank timer-second-bank" aria-hidden="true">
      ${sevenSegmentDigitTemplate('秒钟十位')}
      ${sevenSegmentDigitTemplate('秒钟个位')}
      <span class="timer-decimal"></span>
      ${sevenSegmentDigitTemplate('毫秒百位')}
      ${sevenSegmentDigitTemplate('毫秒十位')}
      ${sevenSegmentDigitTemplate('毫秒个位')}
    </div>
    <span class="sr-only" data-timer-readable>00:00.000</span>
  </div>`;
}

export function renderTimerDisplay(display, elapsedMs) {
  if (!display) return;
  const parts = splitTimerTime(elapsedMs);
  const value = `${parts.minutes}:${parts.seconds}.${parts.milliseconds}`;
  const digitValues = `${parts.minutes}${parts.seconds}${parts.milliseconds}`;
  const digits = [...display.querySelectorAll('[data-timer-digit]')];

  digits.forEach((digit, index) => {
    const valueAtPosition = digitValues[index];
    const activeSegments = SEGMENTS_BY_DIGIT[valueAtPosition] ?? '';
    digit.dataset.value = valueAtPosition;
    digit.querySelectorAll('[data-segment]').forEach((segment) => {
      segment.classList.toggle('is-lit', activeSegments.includes(segment.dataset.segment));
    });
  });

  const readable = display.querySelector('[data-timer-readable]');
  if (readable) readable.textContent = value;
  display.setAttribute('aria-label', `计时 ${parts.minutes}分${parts.seconds}秒${parts.milliseconds}毫秒`);
}
